import {groq} from 'next-sanity';

import {ARTICLE_IN_CARD_FRAGMENT} from '@/modules/article/sanity/query';
import {LINK_FRAGMENT} from '@/modules/foundation/sanity/link/query';
import {PORTABLE_TEXT_FRAGMENT} from '@/modules/foundation/sanity/portable-text/query';

import {DOCUMENT_TYPE_SITE_SETTINGS} from './constants';

const FIELD_OF_AREA_EXTRA_FRAGMENT = `//groq
	resourceLinks[] {
		${LINK_FRAGMENT}
	},
	importantArticles[]-> {
		${ARTICLE_IN_CARD_FRAGMENT},
	}
`;

const SITE_SETTINGS_FRAGMENT = `//groq
	...,
	insurance {
		${FIELD_OF_AREA_EXTRA_FRAGMENT}
	},
	bank {
		${FIELD_OF_AREA_EXTRA_FRAGMENT}
	},
	collection {
		${FIELD_OF_AREA_EXTRA_FRAGMENT}
	},
	footerDescription[] {
		${PORTABLE_TEXT_FRAGMENT}
	},
	footerLinkGroups[] {
		...,
		links[] {
			${LINK_FRAGMENT}
		}
	}
`;

export const siteSettingsQuery = groq`
	*[_type == "${DOCUMENT_TYPE_SITE_SETTINGS}"][0] {
		...,
		${SITE_SETTINGS_FRAGMENT}
	}
`;
